import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/auth/service/user.service';
import { DateHelperService } from 'src/app/services/date-helper.service';
import { UserCardioService } from 'src/app/services/user-cardio.service';

@Component({
  selector: 'app-fit-all-entries',
  templateUrl: './fit-all-entries.component.html',
  styleUrls: ['./fit-all-entries.component.scss'],
})
export class FitAllEntriesComponent implements OnInit {
  isLoading = false;
  userData: any;
  cardioMinsWeek: any;
  cardioLast7Days: any;
  allEntries: any;
  cardioWeekData: any;
  allWeeksData: any = [];
  userWeek: any;
  exercises:any;

  public currentWeek: Date[] = this.dateHelperService.getCurrentWeek();
  public today = this.dateHelperService.getToday();
  constructor(
    private dateHelperService: DateHelperService,
    private userService: UserService,
    private router: Router,
    public userCardioService: UserCardioService,
  ) {}
  ngOnInit(): void {
    forkJoin({
      allEntries: this.userCardioService.fetchAll(),
      exercises : this.userCardioService.fetchExercises()
    }).subscribe((responseData) => {
      this.allEntries = responseData.allEntries;
      this.exercises = responseData.exercises;

      this.cardioWeekData = this.userCardioService.generateWeekData(
        this.currentWeek,
        this.allEntries
      );

      this.allWeeksData.push(this.cardioWeekData);
      let endOfWeek = this.currentWeek[6];
      let weeksRun = 0;
      this.userService.userData.subscribe((userData) => {
        this.isLoading = false;
        if (userData) {
          this.userData = userData;
          while (
            moment(endOfWeek).subtract(1, 'week') >
              moment(this.userData.date_registered) &&
            weeksRun < 100
          ) {
            weeksRun++;
            let prevWeek = this.dateHelperService.getWeekFor(
              moment(endOfWeek).subtract(1, 'week')
            );
            let prevWeekData = this.userCardioService.generateWeekData(
              prevWeek,
              this.allEntries
            );
            this.allWeeksData.push(prevWeekData);
            endOfWeek = prevWeek[6];
          }
          this.userWeek = this.allWeeksData.length;
        }
      });
    });
  }

  getExercise(exercise_id:any){
    let exerciseName = '';
    if(this.exercises){
      this.exercises.forEach((exercise:any)=>{
        if(exercise.exercise_id == exercise_id){
          exerciseName = exercise.name;
        }
      });
    }

    return exerciseName;

  }
}
